import axios from 'axios';

// API base: same origin (Pages serves functions at /api/*)
const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cms_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith('/login')) {
      localStorage.removeItem('cms_token');
      localStorage.removeItem('cms_profile');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
